import React, { useState } from 'react';
import { processFormSubmission } from '../../utils/formSubmission';

const projects = ['Goldcrest Views', 'Giga Mall Extension'];

const HeroContactForm = () => {
    const [name, setName] = useState('');
    const [project, setProject] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!name.trim() || !project || !whatsapp.trim()) {
            return;
        }

        setIsSubmitting(true);
        processFormSubmission(
            {
                name,
                contact: whatsapp,
                whatsapp,
                project,
                message: 'Homepage interest registration',
                source: 'Homepage Hero',
                contactOptional: true,
                useHeroSheet: true,
                waitForSheet: false
            },
            () => {
                setName('');
                setProject('');
                setWhatsapp('');
                setIsSubmitting(false);
            },
            () => {
                setIsSubmitting(false);
            }
        );
    };

    return (
        <form className="hero-glass-form" onSubmit={handleSubmit}>
            <h2>Register Your Interest</h2>
            <input
                type="text"
                name="name"
                value={name}
                onChange={(event) => setName(event.target.value)}
                placeholder="Full Name"
                aria-label="Full Name"
                required
            />
            <select
                name="project"
                value={project}
                onChange={(event) => setProject(event.target.value)}
                aria-label="Project"
                required
            >
                <option value="">Project</option>
                {projects.map((item) => (
                    <option key={item} value={item}>{item}</option>
                ))}
            </select>
            <input
                type="tel"
                name="whatsapp"
                value={whatsapp}
                onChange={(event) => setWhatsapp(event.target.value.replace(/\D/g, ''))}
                placeholder="WhatsApp Number"
                aria-label="WhatsApp Number"
                inputMode="numeric"
                pattern="[0-9]*"
                required
            />
            <button type="submit" className="theme-btn" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Submit Interest'}
            </button>
        </form>
    );
};

export default HeroContactForm;
